import Connectivity from '../connectivity'

export const watchConnectivityThunk = () => dispatch => {
  dispatch(navigator.onLine ? Connectivity.connectionRestored() : Connectivity.connectionLost())
  window.addEventListener('online', () => dispatch(Connectivity.connectionRestored()))
  window.addEventListener('offline', e => dispatch(Connectivity.connectionLost(e)))
}
